import { LanguagesEnum, LanguagesEnumType } from '@enums/languages.enum';
import localeEnGb from '@angular/common/locales/en-GB';
import localeNl from '@angular/common/locales/nl';
import localeNlBe from '@angular/common/locales/nl-BE';
import localeFr from '@angular/common/locales/fr';

export interface Language {
  title: string;
  locale: any;
  value: LanguagesEnumType;
}

export class LanguagesConstant {
  availableLanguages: Language[] = [
    {
      title: 'English',
      locale: localeEnGb,
      value: LanguagesEnum['en-GB'],
    },
    {
      title: 'Nederlands',
      locale: localeNl,
      value: LanguagesEnum['nl-NL'],
    },
    {
      title: 'Vlaams',
      locale: localeNlBe,
      value: LanguagesEnum['nl-BE'],
    },
    {
      title: 'Français',
      locale: localeFr,
      value: LanguagesEnum['fr-FR'],
    },
  ];
}
